import React, { useEffect } from "react";

const AdSenseAd = ({ slot = "4706915783", format = "auto" }) => {
  useEffect(() => {
    // Load AdSense script once
    const existingScript = document.querySelector(
      'script[src*="pagead2.googlesyndication.com/pagead/js/adsbygoogle.js"]'
    );

    if (!existingScript) {
      const script = document.createElement("script");
      script.src =
        "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-5860038050812499";
      script.async = true;
      script.crossOrigin = "anonymous";
      document.body.appendChild(script);
    }

    // Push ads once script is loaded
    const interval = setInterval(() => {
      if (window.adsbygoogle && window.adsbygoogle.push) {
        window.adsbygoogle.push({});
        clearInterval(interval);
      }
    }, 500);

    return () => clearInterval(interval);
  }, []);

  return (
    <ins
      className="adsbygoogle"
      style={{ display: "block" }}
      data-ad-client="ca-pub-5860038050812499"
      data-ad-slot={slot}
      data-ad-format={format}
      data-full-width-responsive="true"
    ></ins>
  );
};

export default AdSenseAd;
